import { Card, Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { getChatCount } from "../APIs/firebaseDashboardApis";
import { DashboardContext } from "../contexts/DashboardContextProvider";

const VisitorAnalyticsWidget = ({ propertyIds, dateRange, rangeLabel }) => {
  const { setChatCountCallback } = useContext(DashboardContext);

  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (propertyIds?.length > 0 && dateRange.length > 0) {
      const fetchChatCount = async () => {
        setLoading(true);
        const response = await getChatCount({ propertyIds, dateRange })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setLoading(false);
          });
        setChatCountCallback(response);
        const tempCount = response?.reduce(
          (prev, curr) => prev + (curr.chatCount || 0),
          0
        );
        setCount(tempCount);
      };
      fetchChatCount();
    }
  }, [propertyIds, dateRange, setChatCountCallback]);

  return (
    <Spin spinning={loading}>
      <Card
        className="dashboard_card"
        title={
          <>
            <i className="fa-regular fa-comment"></i>
            <span className="card_title">Chats</span>
          </>
        }
      >
        <div className="card-stats-body">
          <p className="stats-body-number-heading">{rangeLabel}</p>
          <p className="stats-body-number">{count}</p>
        </div>
      </Card>
    </Spin>
  );
};

export default React.memo(VisitorAnalyticsWidget);
